export enum RegistryStatus {
  LIBERO = 'LIBERO',
  OCCUPATO = 'OCCUPATO',
}
